import { Navigate } from "react-router-dom";
import { featureFlags } from "./featureConfig";
import { VENDOR_PATHS } from "./vendorNavPaths";

import Dashboard from "../components/Vendor/dashboard/dashboard";
import Notifiche from "../components/Vendor/notifiche/notifiche";
import PrivacyPolicy from "../components/Vendor/privacyPolicy";
import Caricamenti from "../components/Vendor/catalogo/caricamenti/caricamenti";
import Prodotti from "../components/Vendor/catalogo/prodotti/prodotti";
import HistoryVendor from "../components/Vendor/catalogo/historyVendor";
import GestioneBudget from "../components/Vendor/ricariche/gestioneBudget";
import DettaglioMovimenti from "../components/Vendor/fatturazione/dettaglioMovimenti";
import Fatturazione from "../components/Vendor/fatturazione/fatturazione";
import Ricarica from "../components/Vendor/ricariche/ricarica";
import ProfiloVendor from "../components/Vendor/profile/profilo";
import Ticket from "../components/Vendor/ticket/ticket";

const ricaricheEnabled = featureFlags.enableRicariche;
const fatturazioneEnabled = featureFlags.enableFatturazione;
export const vendorRoutes = [
  { path: VENDOR_PATHS.DASHBOARD, requiredRole: "vendor", element: <Dashboard />, enabled: true },
  { path: VENDOR_PATHS.CATALOGO_CSV, requiredRole: "vendor", element: <Caricamenti />, enabled: true },
  { path: VENDOR_PATHS.GESTIONE_PRODOTTI, requiredRole: "vendor", element: <Prodotti />, enabled: true },

  { path: VENDOR_PATHS.RICARICHE, requiredRole: "vendor", element: <GestioneBudget />, enabled: ricaricheEnabled },
  { path: VENDOR_PATHS.RICARICA, requiredRole: "vendor", element: <Ricarica />, enabled: ricaricheEnabled },

  { path: VENDOR_PATHS.FATTURAZIONE, requiredRole: "vendor", element: <Fatturazione />, enabled: fatturazioneEnabled },
  { path: VENDOR_PATHS.DETTAGLIO_MOVIMENTI, requiredRole: "vendor", element: <DettaglioMovimenti />, enabled: fatturazioneEnabled },

  { path: VENDOR_PATHS.NOTIFICHE, requiredRole: "vendor", element: <Notifiche />, enabled: true },
  { path: VENDOR_PATHS.TICKET, requiredRole: "vendor", element: <Ticket />, enabled: true },
  { path: "/reportIssue", requiredRole: "vendor", element: <Navigate to={VENDOR_PATHS.TICKET} replace />, enabled: true },
  { path: VENDOR_PATHS.HISTORY_VENDOR, requiredRole: "vendor", element: <HistoryVendor />, enabled: true },

  { path: VENDOR_PATHS.PROFILO, requiredRole: "vendor", element: <ProfiloVendor />, enabled: true },

  { path: VENDOR_PATHS.PRIVACY, requiredRole: "vendor", element: <PrivacyPolicy />, enabled: true },
];

